import { email, required } from "vuelidate/lib/validators";

export default class VendedorData {
  nome = "";

  cpf = "";

  rg = "";

  email = "";

  telefone = "";

  cep = "";

  logradouro = "";

  numero = "";

  complemento = "";

  bairro = "";

  id_cidade = null;

  cidade = null;

  status = true;

  id_vendedor = null;

  comissao_vista = 0;

  comissao_prazo = 0;

  constructor({
    nome = "",
    cpf = "",
    rg = "",
    email = "",
    telefone = "",
    cep = "",
    logradouro = "",
    numero = "",
    complemento = "",
    bairro = "",
    id_cidade = null,
    cidade = null,
    status = true,
    id_vendedor = null,
    comissao_vista = 0,
    comissao_prazo = 0,
  }) {
    this.nome = nome;
    this.cpf = cpf;
    this.rg = rg;
    this.email = email;
    this.telefone = telefone;
    this.cep = cep;
    this.logradouro = logradouro;
    this.numero = numero;
    this.complemento = complemento;
    this.bairro = bairro;
    this.id_cidade = id_cidade;
    this.cidade = cidade;
    this.status = status;
    this.id_vendedor = id_vendedor;
    this.comissao_vista = comissao_vista;
    this.comissao_prazo = comissao_prazo;
  }
}

export const VendedorDataValidations = {
  nome: {
    required,
  },
  email: {
    email,
  },
};
